import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';
import { MOBILE_NAV_TRANSITION_SPEED } from 'common/consts/navigation';

const MobileNavSection = styled.div`
  position: relative;
  display: block;
  transition-duration: ${MOBILE_NAV_TRANSITION_SPEED};
  padding: ${ds.get('metrics.xs')} 0;
  
  ${media.mobile`
    display: ${({ isPortraitOrientation }) => (isPortraitOrientation ? 'block' : 'inline-block')};
    vertical-align: top;
    padding: 0 calc(${ds.get('metrics.xs')} * 2) ${ds.get('metrics.s')} calc(${ds.get('metrics.xs')} * 2);
  `}
  
  ${media.tablet`
    padding: ${ds.get('metrics.s')} ${ds.get('metrics.l')};
  `}
`;

export default MobileNavSection;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MobileNavigation/MobileNavSection.jsx